import React, { forwardRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { WebHaptics } from 'web-haptics';

const haptics = new WebHaptics();

export function hapticTap() {
  haptics.trigger('medium');
}

export function useHaptics() {
  const tap = useCallback(() => {
    haptics.trigger('medium');
  }, []);

  return { tap };
}

export const HapticLink = forwardRef(({ onClick, ...props }, ref) => (
  <Link
    ref={ref}
    {...props}
    onClick={(e) => {
      haptics.trigger('medium');
      if (onClick) onClick(e);
    }}
  />
));

export function useHapticNavigate() {
  const navigate = useNavigate();

  return useCallback((...args) => {
    haptics.trigger('medium');
    return navigate(...args);
  }, [navigate]);
}
